export const noop = () => {};
export default noop;


// WEBPACK FOOTER //
// ./src/Base/utils/noop.js